"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Table_1 = __importDefault(require("./Table"));

var Column_1 = __importDefault(require("./Column"));

exports.Column = Column_1.default;

var ColumnGroup_1 = __importDefault(require("./ColumnGroup"));

exports.ColumnGroup = ColumnGroup_1.default;

var utils_1 = require("./utils");

exports.INTERNAL_COL_DEFINE = utils_1.INTERNAL_COL_DEFINE;
exports.default = Table_1.default;


//////////////////
// WEBPACK FOOTER
// ../~/rc-table/es/index.js
// module id = 2715
// module chunks = 1